import {useContext, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {ItensImoveisProps, Tipologia} from '../components/Types'
import {BiAddToQueue, BiLinkExternal} from 'react-icons/bi'
import {DataContext} from '../context/DataContext'
import {formatDate, formatNumber} from '../../explorer/components/common'
import secureLocalStorage from 'react-secure-storage'
import * as XLSX from 'xlsx'

export function ModalDados() {
  const [show, setShow] = useState(false)
  const {data} = useContext(DataContext)

  let usuarioOrulo = secureLocalStorage.getItem('usuario_orulo')

  function closeModal() {
    setShow(false)
  }

  function openModal() {
    setShow(true)
  }

  function exportar(data) {
    const dataToExport = []
    // eslint-disable-next-line array-callback-return
    data.map((item: ItensImoveisProps) => {
      // eslint-disable-next-line array-callback-return
      item.tipologias.map((itemTipologia: Tipologia) => {
        if (itemTipologia.computed) {
          let [year, month, day] = item.data_lancamento.split('T')[0].split('-')
          let dataLancamento = new Date(Number(year), Number(month) - 1, Number(day), 12, 0, 0)

          let [year2, month2, day2] = item.data_preco.split('T')[0].split('-')
          let dataPreco = new Date(Number(year2), Number(month2) - 1, Number(day2), 12, 0, 0)

          let [year3, month3, day3] = item.opening_date.split('T')[0].split('-')
          let dataEntrega = new Date(Number(year3), Number(month3) - 1, Number(day3), 12, 0, 0)

          dataToExport.push({
            Situação: item.situacao,
            Nome: item.nome,
            Endereço: item.endereco,
            'Nome Incorporador': item.nome_incorporador,
            'Data Lançamento': dataLancamento,
            'Data Entrega': dataEntrega,
            'Área Privativa': itemTipologia.private_area ? itemTipologia.private_area : 0,
            Vagas: itemTipologia.parking,
            Suítes: itemTipologia.suites,
            Dormitórios: itemTipologia.bedrooms,
            Tipo: itemTipologia.type,
            'Preço Inicial': itemTipologia.preco_lancamento ? itemTipologia.preco_lancamento : '0',
            'Preço Inicial m²': itemTipologia.preco_lancamento
              ? Number((itemTipologia.preco_lancamento / itemTipologia.private_area).toFixed(2))
              : 0,
            'Preço Estoque': itemTipologia.original_price,
            'Preço Estoque m²':
              itemTipologia.private_area > 0
                ? Number((itemTipologia.original_price / itemTipologia.private_area).toFixed(2))
                : 0,
            'Preço Estoque INCC': itemTipologia.preco_corrigido_incc,
            'Preço Inicial INCC': itemTipologia.preco_lancamento_incc_data_atual,
            'Valorização Real Mensal': (itemTipologia.valorizacao_incc_mensal * 100).toFixed(1),
            'Total Unidades': itemTipologia.total_units,
            Estoque: itemTipologia.stock,
            Vendas: itemTipologia.total_units - itemTipologia.stock,
            '% Vendas': itemTipologia.vendas_perc_tip,
            'Venda Mensal': itemTipologia.venda_mensal.toFixed(1) + '/mês',
            'Data Preço': dataPreco,
            'Meses Mercado': itemTipologia.meses_mercado,
            Site: item.webpage,
          })
        }
      })
    })

    const worksheet = XLSX.utils.json_to_sheet(dataToExport, {cellDates: true})
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, worksheet, 'Planilha de Dados')
    XLSX.writeFile(wb, `Inteligência de Mercado.xlsx`)
  }

  return (
    <>
      <button
        onClick={openModal}
        className='btn btn-light-primary btn-sm d-block me-2 w-100'
        style={{width: '100% !important'}}
      >
        <BiAddToQueue className='fs-2 me-1' />
        Tabela de Dados
      </button>
      <Modal centered animation show={show} onHide={() => closeModal()} fullscreen={true}>
        <Modal.Header closeButton className='d-flex'>
          <Modal.Title>Tabela de empreendimentos</Modal.Title>
        </Modal.Header>
        <Modal.Body className='modal-xl' style={{width: '100%'}}>
          <div className='row mb-5'>
            <div className='col-md-12'>
              {usuarioOrulo ? (
                <button
                  className='btn btn-primary pull-right'
                  style={{margin: '0 auto'}}
                  onClick={() => exportar(data)}
                >
                  Exportar dados
                </button>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <table className='table  gs-5 '>
                <thead>
                  <tr>
                    <th>
                      <input type='checkbox' />
                    </th>
                    <th>Situação</th>
                    <th>Nome</th>
                    <th>Endereço</th>
                    <th>Incorporadora</th>
                    <th className='text-center'>Data Lançamento</th>
                    <th className='text-center'>Data Entrega</th>
                    <th className='text-center'>Área Privativa</th>
                    <th className='text-center'>Vagas</th>
                    <th className='text-center'>Suítes</th>
                    <th className='text-center'>Dormitórios</th>
                    <th>Tipo</th>
                    <th className='text-center'>Preço Inicial</th>
                    <th className='text-center'>Preço Inicial m²</th>
                    <th className='text-center'>Preço Estoque </th>
                    <th className='text-center'>Preço Estoque m²</th>
                    <th className='text-center'>Preço Estoque INCC</th>
                    <th className='text-center'>Preço Inicial INCC</th>
                    <th className='text-center'>Valorização Real Mensal</th>

                    <th className='text-center'>Total Unidades</th>

                    <th className='text-center '>Estoque</th>
                    <th className='text-center'>Vendas</th>
                    <th className='text-center '>Venda Mensal</th>
                    <th className='text-center'>Data Preço</th>
                    <th className='text-center'>Meses Mercado</th>

                    {/* <th className='text-center'>Mese entre lanmeses_dif_lancamento_ultimo_preco</th> */}
                    <th className='text-center'>Site</th>
                  </tr>
                </thead>
                <tbody>
                  {data ? (
                    data.map((item: ItensImoveisProps) => {
                      return item.tipologias.map((itemTipologia: Tipologia) => {
                        let background =
                          item.removed || itemTipologia.computed === false ? '#ffc3c3' : 'white'

                        return (
                          <tr style={{backgroundColor: background, border: 1, borderColor: '#333'}}>
                            <td>
                              <input type='checkbox' />
                            </td>
                            <td>{item.situacao}</td>
                            <td>{item.nome}</td>
                            <td>{item.endereco}</td>
                            <td>{item.nome_incorporador}</td>
                            <td className='text-center'>{formatDate(item.data_lancamento)}</td>
                            <td className='text-center'>{formatDate(item.opening_date)}</td>
                            <td className='text-center'>
                              {formatNumber(itemTipologia.private_area, 'decimal')}
                            </td>
                            <td className='text-center'>{itemTipologia.parking}</td>
                            <td className='text-center'>{itemTipologia.suites}</td>
                            <td className='text-center'>{itemTipologia.bedrooms}</td>
                            <td>{itemTipologia.type}</td>

                            <td className='text-right'>
                              {formatNumber(itemTipologia.preco_lancamento, 'currency')}
                            </td>
                            <td className='text-right'>
                              {formatNumber(
                                itemTipologia.preco_lancamento / itemTipologia.private_area,
                                'currency'
                              )}
                            </td>

                            <td className='text-right'>
                              {formatNumber(itemTipologia.original_price, 'currency')}
                            </td>

                            <td className='text-right'>
                              {formatNumber(
                                itemTipologia.original_price / itemTipologia.private_area,
                                'currency'
                              )}
                            </td>
                            <td className='text-center'>
                              {formatNumber(itemTipologia.preco_corrigido_incc, 'currency')}
                            </td>
                            <td className='text-center'>
                              {formatNumber(
                                itemTipologia.preco_lancamento_incc_data_atual,
                                'currency'
                              )}
                            </td>
                            <td className='text-center'>
                              {(itemTipologia.valorizacao_incc_mensal * 100).toFixed(1)}%
                            </td>

                            <td className='text-center'>{itemTipologia.total_units}</td>
                            <td className='text-center'>{itemTipologia.stock}</td>
                            <td className='text-center'>
                              {itemTipologia.total_units - itemTipologia.stock}
                            </td>
                            <td className='text-center'>{itemTipologia.vendas_perc_tip}</td>
                            <td className='text-center'>
                              {itemTipologia.venda_mensal.toFixed(1)}/mês
                            </td>
                            <td className='text-center'>{formatDate(itemTipologia.data_preco)}</td>
                            <td className='text-center'>{itemTipologia.meses_mercado}</td>

                            {/* <td className='text-center'>
                              {itemTipologia.meses_dif_lancamento_ultimo_preco}
                            </td> */}
                            <td className='text-center'>
                              <a href={item.webpage} target='_blank' rel='noreferrer'>
                                <BiLinkExternal></BiLinkExternal>
                              </a>
                            </td>
                          </tr>
                        )
                      })
                    })
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
